import { Component, inject, input, output, signal } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { FriendlyFilenamePipe } from "../../pipes/friendly-filename.pipe";

@Component({
  selector: 'app-display-file',
  standalone: true,
  imports: [
    FriendlyFilenamePipe
  ],
  templateUrl: './display-file.component.html',
  styleUrl: './display-file.component.css'
})
export class DisplayFileComponent {

  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  filename = input<string>('');
  splitted = input<boolean>(false);
  creation = input<boolean>(false);
  isLoading = signal<boolean>(false);

  remove = output<string>();

  get originalName(): string {
    const name = this.filename() ?? '';
    return name.includes('/') ? name.split('/').pop()! : name;
  }

  downloadSource(sourceName: string) {
    this.isLoading.set(true);
    this.http
      .get(
        this.apiUrl +
        `/reconciliations/download?file=${sourceName}`,
        { responseType: 'blob' }
      )
      .subscribe((data: Blob) => {
        const blob = new Blob([data], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');

        link.href = url;
        link.download = sourceName;
        link.click();

        window.URL.revokeObjectURL(url);
        this.isLoading.set(false);
      });
  }

  removeFile(filename: string) {
    this.remove.emit(filename);
  }

}
